import React, { useEffect, useState } from "react";
import { TextField, PrimaryButton } from "@fluentui/react";
import { processAndUpdateToken } from "../Services/CommonFunctions";
import axios from "axios";
import { baseUrl } from "../Services/Constants";
import CommonDataTable from "./CommonDataTable";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CleanDataDialog from "./CleanDataDialog";

const ActualLobDialog = (props) => {
  const { selectChange } = props;
  const [searchText, setSearchText] = useState("");
  const [selectedJobId, setSelectedJobId] = useState("");
  const [jobInstance, setJobInstance] = useState([]);
  const [jobInstanceFiltered, setJobInstanceFiltered] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [isSearch, setIsSearch] = React.useState(false);


  const column = [
    // {
    //   name: "S.No",
    //   selector: (row, index) => index + 1,
    //   sortable: true,
    //   width:"5.5%"
    //   // style: { fontSize: "11px !important" },
    // },
    {
      name: "Lob",
      selector: (row) => row.Lob,
      sortable: true,
      width:"8%",
      // style: { fontSize: "16px" },

    },
    {
      name: "Carrier",
      selector: (row) => row?.Carrier,
      width:"20%",
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word", overflow: "hidden" }}>
          {row.Carrier}
        </div>
      )

    },
    {
      name: "Document",
      selector: (row) => row?.Document,
      sortable: true,
      width:"10%"

    },
    {
      name: "Question",
      selector: (row) => row?.Question,
      width:"12%",
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word", overflow: "hidden" }}>
          {row.Question}
        </div>
      ),

    },
  
    {
      name: "ChecklistQuestion",
      selector: (row) => row?.ChecklistQuestion,
      sortable: true,
      width: "20%",
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word", overflow: "hidden" }}>
          {row.ChecklistQuestion}
        </div>
      ),
    },
    {
      name: "Short Question",
      selector: (row) => row?.ShortQuestion,
      width:"15%"

    },
    {
      name: "STP Status",
      selector: (row) => row?.StpStatus,
      width:"10%"

    },
    // {
    //   name: "Is Active",
    //   cell: (row) => row?.IsActive === true || row?.IsActive === 'true' ? 'true' : 'false',
    //   width:"7%"

    // },
    
    // {
    //   name: "Quality",
    //   selector: (row) => row?.Quality,
    //   width:"8%"

    // },
    // {
    //   name: "Noise",
    //   selector: (row) => row?.Noise,
    //   width:"6%"

    // },
    
    
    
    
  ];

  useEffect(() => {
    getData();
  }, [props]);


  const handleDialogClose = (event, reason) => {
    if (reason == "backdropClick") {
      return;
    }
    setOpen(false);
  };

  const getData = async () => {
    const lobCode=props.lobCode;
    let token = sessionStorage.getItem("token");
    document.body.classList.add("loading-indicator");
    token = await processAndUpdateToken(token);
    if(lobCode){try {
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        baseUrl + `/api/JobConfiguration/GetStpMappingDataByLob?lob=${lobCode}`,
        {
          headers,
        }
      );
      document.body.classList.remove("loading-indicator");
      if (response.status !== 200) {
        return "failed";
      }
      if (response?.data) {
        setJobInstance(response.data);
        setJobInstanceFiltered([]);
      } else {
        return "failed";
      }
    } catch (error) {
      document.body.classList.remove("loading-indicator");
      return "failed";
    }
  }
  };

  const filterData = () => {
    if (searchText?.trim()) {
      const searchTerm = searchText.toLowerCase().trim();
  
      const filteredData = jobInstance?.filter((f) =>
        (f?.Carrier?.toLowerCase()?.trim()?.includes(searchTerm))
      );
  
      setJobInstanceFiltered(filteredData);
      setIsSearch(true);
    } else {
      setJobInstanceFiltered([]);
      setIsSearch(false);
    }
  };
  
  const onChange = (event) => {
    const text = event.target.value;
    setSearchText(text); // Update state immediately
  
    if (text?.trim()) {
      const searchTerm = text.toLowerCase().trim();
  
      const filteredData = jobInstance?.filter((f) =>
        (f?.Carrier?.toLowerCase()?.trim()?.includes(searchTerm))
      );
  
      setJobInstanceFiltered(filteredData);
    } else {
      setJobInstanceFiltered(jobInstance); // Show all data when search is cleared
    }
  };

  return (
    <div style={{ width: "100%", paddingTop: "5px", marginLeft: "5px"}}>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <TextField
          placeholder="Search by Carrier"
          value={searchText}
          onChange={onChange} // Direct function reference
          style={{
                  width: "250px",
                  marginRight: "8px",
                }}
        />
        <PrimaryButton
          text={
            <span style={{ color: "white", fontWeight: "bold" }}>Search</span>
          }
          onClick={() => {
            filterData();
          }}
          style={{
            marginLeft: "-50px",
            height: "32.1px",
            fontSize: "10px",
          }}
        />
      </div>
      <br />
      <div>
        <CommonDataTable
          key={"jData"}
          column={column}
          data={isSearch ? jobInstanceFiltered : jobInstance}
          tableHeight="50vh"
        />
      </div>
      <div>
        <Dialog
          key={"jacD"}
          open={open}
          onClose={handleDialogClose}
          fullScreen={true}
          scroll={"paper"}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Job - {selectedJobId} </span>
              <span style={{ fontSize: "smaller", color: "indianred" }}>
                Click 'esc' key to close
              </span>
            </div>
          </DialogTitle>
          <DialogContent dividers={true} component={"div"}>
            <DialogContentText
              id="scroll-dialog-description"
              tabIndex={-1}
              component={"div"}
            >
              <CleanDataDialog data={{ JobId: selectedJobId }} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button key="bCl" onClick={handleDialogClose}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default ActualLobDialog;